import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCategoryDetails } from "../Items/CategorySlice";

const StockDB = () => {
  const dispatch = useDispatch();

  // Get data from Redux
  const {
    data: categories = [], loading} = useSelector((state) => state.categories);

  // Fetch category details on mount
  useEffect(() => {
    dispatch(getCategoryDetails("stock_list=true"));
  }, [dispatch]);

  if (loading) return <p>Loading ......</p>

  return (
    <div className="flex flex-col bg-green100 p-4 rounded-2xl w-full mt-4 h-auto overflow-y-auto">
      <p className="text-G800 font-semibold text-lg mb-4 text-center">Stock</p>
      {categories?.length > 0 ? (
        <>
          {categories?.map((section, index) => (
            <div key={index} className=" mb-4 flex flex-col">
              <div className="flex gap-3 text-G500">
                <div className="text-sm font-semibold  w-1/3">
                  {section?.name}
                </div>
                <div className="w-2/3 flex justify-between">
                  <ul className="list-disc text-sm">
                    {section?.items?.map((item, i) => (
                      <li key={i}>{item.name}</li>
                    ))}
                  </ul>
                  <ul className="text-sm text-right">
                    {section?.items?.map((item, i) => (
                      <li key={i}>{item.stock_quantity}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < categories?.length - 1 && <hr className="my-3 border-G30" />}
            </div>
          ))}</>) : (<p className="text-center text-G500">No stock available.</p>)}
    </div>
  );
};

export default StockDB;
